export enum Entity {
  Title = 'title',
  TitleGhost = 'titleGhost',
  Date = 'date',
  DateCount = 'dateCount',
  DateSum = 'dateSum',
  Total = 'total',
  TotalCount = 'totalCount',
  TotalSum = 'totalSum',
  IsOnlyTitle = 'isOnlyTitle',
  TitleTotal = 'titleTotal',
  RowInternal = 'rowInternal',
  RowBankCard = 'rowBankCard',
  RowSbp = 'rowSbp',
  RowCash = 'rowCash',
  RowTotal = 'rowTotal',
}

export type TotalsData = Record<
  'bank_card' | 'cash' | 'sbp' | 'internal' | 'total',
  {
    data_by_date: Record<string, { count: number; sum: number }>
    total: {
      count: number
      sum: number
    }
  }
>
